<template>

    <div>
        <form class="myForm mt-5">
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Obra:<span class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <select class="form-control" v-model="obrasSel">
                        <option v-for="(obra, i) in medObra" :key="i" :value="obra.o01_id">{{obra.o01_descricao}}
                        </option>
                    </select>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Data</label>
                <div class="col-sm-4">
                    <datepicker
                            v-model="dtRef"
                            :lang="lang"
                            format="DD/MM/YYYY"
                            @change="validaData"
                    ></datepicker>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Tipo de Serviço:<span
                        class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <select class="form-control" v-model="servicosSel">
                        <option v-for="(servico, i) in servicos" :key="i" :value="servico.c02_id">
                            {{servico.c02_descr}}
                        </option>
                    </select>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Detalhe do Serviço:</label>
                <div class="col-sm-4">
                    <textarea class="form-control" v-model="detServico" rows="3"></textarea>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Fiscal:</label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="fiscal">
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Responsável:</label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="responsavel">
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Percentual Execução:</label>
                <div class="col-sm-4">
                    <the-mask type="text" class="form-control" v-model="percExec" :mask="'#########'"/>
                </div>
            </div>

        </form>
        <hr>
        <h6>Adicionar fotos da medição:</h6>
        <br>
        <div class="row">
            <div class="col-6">
                <vue-dropzone id="drop1" :options="dropOptions" ref="myVueDropzone"
                              v-on:vdropzone-success="dropzoneCallback"></vue-dropzone>
            </div>
            <div class="col-6">
                <label>Descrição</label>
                <textarea class="form-control" rows="3" v-model="desc"></textarea>
                <br>
                <button class="btn btn-sm btn-primary" @click="adicionar" :disabled="!imagemTmp != '' || !desc != ''">Adicionar</button>
            </div>
        </div>
        <br>
        <br>
        <br>

        <div v-if="imagem != ''">
            <table class="table">
                <tr>
                    <td>Imagem</td>
                    <td>Descrição</td>
                    <td>Ações</td>
                </tr>
                <tbody>
                <tr v-for="(imagens, i) in imagem" :key="i">
                    <td><img class="imagem-tabela" :src="imagens.src"></td>
                    <td>{{imagens.descr}}</td>
                    <td>
                        <button class="btn btn-sm btn-danger" title="Excluir" @click="eliminar(i)"><i
                                class="fas fa-trash"></i></button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
            <button class="btn btn-sm btn-success ml-2"
                    :disabled="(!dtRef != '' || !obrasSel != '' || !servicosSel != '' || !percExec != '' || img == true)"
                    @click="salvar">Salvar
            </button>
        </div>
    </div>
</template>

<script>
    import MenuInterno from '../menu-interno/MenuInterno.vue'
    import vueDropzone from "vue2-dropzone";
    import Datepicker from 'vue2-datepicker'

    var uploadFoto, uploadCampo;

    export default {
        name: 'MedicoesEditar',
        components: {
            MenuInterno,
            vueDropzone,
            Datepicker
        },
        props: {
            id: Number
        },
        data() {
            return {
                medObra: '',
                dtRef: '',
                servicos: '',
                detServico: '',
                fiscal: '',
                responsavel: '',
                percExec: '',
                obrasSel: '',
                servicosSel: '',
                desc: '',
                imagemTmp: '',
                imageData: '',
                dropOptions: {
                    url: axios.defaults.baseURL+"/api/sist-obras/medicoes/upload-img",
                    thumbnailWidth: 120,
                    thumbnailHeight: 120,
                    dictDefaultMessage: "<i class='fas fa-cloud-upload-alt'></i> <br>Clique aqui para enviar uma foto",
                    addRemoveLinks: true,
                    maxFiles: 1,
                    headers: {
                        'Authorization': 'Bearer '+Store.getters.pegaAccessToken
                    }
                },
                imagem: [],
                lang: {
                    days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                    months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    pickers: ['próximos 7 dias', 'próximos 30 dias', '7 dias atrás', '30 dias atrás'],
                    placeholder: {
                        date: 'Selecione uma Data',
                        dateRange: 'Selecione um range de Datas'
                    }
                },
                img: false
            }
        },
        methods: {
            retorno() {
                this.$router.go(0)
            },
            formataData(dt){
                return new Date(dt).toLocaleDateString('ko-KR', {
                    year : 'numeric',
                    month : '2-digit',
                    day : '2-digit'
                }).split('. ').join('-').replace('.','');
            },
            adicionar() {
                this.imagemTmp.descr = this.desc
                this.desc = ''
                this.imagemTmp.src = $('.dz-image img').attr('src')
                this.$refs.myVueDropzone.removeAllFiles()
                this.imagem.push(this.imagemTmp)
                this.img = false
            },
            eliminar(i) {
                this.imagem.splice(i, 1)
            },
            dropzoneCallback(file, response) {
                this.imagemTmp = {img: response, descr: '', src: ''}
                this.img = true
            },
            validaData(){
                if(new Date(this.dtRef).getTime() > Date.now()){
                    this.dtRef = '';
                    this.$swal('Atenção!', 'A data da medição deve ser menor que a data atual', 'error')
                }
            },
            salvar() {
                API.enviarRequisicao('put', '/api/sist-obras/medicoes/' + this.id, {
                    o03_refer: this.formataData(this.dtRef),
                    o03_descr_serv: this.detServico,
                    o03_fiscal_obra: this.fiscal,
                    o03_respons_tecnico: this.responsavel,
                    o03_medicao_percent: this.percExec,
                    o03_obra_id: this.obrasSel,
                    o03_tpservico_id: this.servicosSel,
                    o02_path_img: this.imagem
                })
                    .then(response => {
                        this.$swal('Parabéns!', 'Dados salvos com sucesso.', 'success')
                            .then(
                                function () {
                                    history.go(0);
                                }
                            )
                    })
                    .catch(function (error) {
                        this.$swal('Atenção!', 'Erro ao cadastrar os dados.', 'error')
                    })
            }
        },
        mounted: function () {
            API.enviarRequisicao('get', '/api/sist-obras/obras')
                .then(response => {
                    this.medObra = response.data
                }),
                API.enviarRequisicao('get', '/api/sist-obras/tipo-servicos')
                    .then(response => {
                        this.servicos = response.data
                    }),
                API.enviarRequisicao('get', '/api/sist-obras/medicoes/' + this.id)
                    .then(response => {
                            this.dtRef = response.data.o03_refer.replace('-','/'),
                            this.detServico = response.data.o03_descr_serv,
                            this.fiscal = response.data.o03_fiscal_obra,
                            this.responsavel = response.data.o03_respons_tecnico,
                            this.percExec = response.data.o03_medicao_percent,
                            this.obrasSel = response.data.o03_obra_id,
                            this.servicosSel = response.data.o03_tpservico_id

                        for (var i = 0; i < response.data.obra_fotos.length; i++) {
                            this.imagem.push({
                                img: response.data.obra_fotos[i].o02_path_img,
                                descr: response.data.obra_fotos[i].o02_descr,
                                src: axios.defaults.baseURL + '/api/assets/SistObras/' + response.data.obra_fotos[i].o02_path_img
                            })
                            this.contador++
                        }
                    })

        }
    }
</script>

<style scoped>

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

    .dz-clickable {
        width: 200px;
        height: 100px;
        padding: 0;
        color: #aaa;
        border-radius: 15px;
        text-align: center;
    }

    .dz-remove {
        margin-left: 0;
        border: none;
    }

    .imagem-tabela {
        width: 150px;
        height: 150px;
    }

    .mx-datepicker{
        width: 100%;
    }
</style>
